export type AuthSideEffects = {
  setPolicies: (policies: number[]) => void
  resetState: () => void
}

let sideEffects: AuthSideEffects | null = null

export const registerAuthSideEffects = (effects: AuthSideEffects) => {
  sideEffects = effects
}

export const unregisterAuthSideEffects = () => {
  sideEffects = null
}

export const getAuthSideEffects = (): AuthSideEffects | null => sideEffects
